import React from "react";
import { useParams } from "react-router";

// Material-ui
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

// Locals
import { useCurrentWsDetail } from "../../firebase";
import { useUpdateWorkspace } from "../api";
import { Params } from "../../routes";
import { Loading, Select } from "../../components";
import { DateFormatOption } from "../types";
import useStyles from "../styles";

const dateFormatOptions: DateFormatOption[] = ["dd.MM.yyyy", "MM/dd/yyyy"];
export const defaultDateFormatOption = dateFormatOptions[0];

type Option = {
  value: DateFormatOption;
  title: DateFormatOption;
};

const DateFormatOptionSelect: React.FC = () => {
  const classes = useStyles();
  const wsDetail = useCurrentWsDetail();
  const { workspaceId } = useParams<Params>();
  const updateWorkspace = useUpdateWorkspace();
  const [format, setFormat] = React.useState<DateFormatOption>(
    wsDetail?.dateFormat ?? defaultDateFormatOption,
  );
  const [loading, setLoading] = React.useState<boolean>(false);

  const onHandleChange = React.useCallback(
    async (e) => {
      if (workspaceId && wsDetail) {
        const { value } = (e as React.ChangeEvent<Option>).target;
        setLoading(true);
        await updateWorkspace({ dateFormat: value }, workspaceId);
        setFormat(value);
        setLoading(false);
      }
    },
    [updateWorkspace, workspaceId, wsDetail],
  );

  return (
    <Box className={classes.editableInfoRow} style={{ marginTop: 20 }}>
      <Box className={classes.infoContent}>
        <Typography className={classes.infoLabel}>Date Format</Typography>
        {loading ? (
          <Loading size={20} />
        ) : (
          <Select
            options={dateFormatOptions.map((dateFormat) => ({
              value: dateFormat,
              title: dateFormat,
            }))}
            value={format}
            onChange={onHandleChange}
          />
        )}
      </Box>
    </Box>
  );
};

export default DateFormatOptionSelect;
